<ng-container [ngSwitch]="treatmentType">
  <app-peptide-therapy-ed *ngSwitchCase="ConsultationTreatmentTypes.Ed" />
  <app-peptide-therapy-trt *ngSwitchCase="ConsultationTreatmentTypes.Trt" />
  <app-peptide-therapy-trt *ngSwitchCase="ConsultationTreatmentTypes.TrtRenewal" />
  <app-peptide-therapy-hair-loss *ngSwitchCase="ConsultationTreatmentTypes.HairLoss" />
  <app-peptide-therapy *ngSwitchDefault />
</ng-container>
